import React from 'react';
import { Route } from 'react-router-dom';
import HeaderBack from '../../../../containers/Headers/components/HeaderBack/HeaderBack';
import Headers from '../../../../containers/Headers/Headers';
import { SCREENS } from '../../../../../constants/screens';
import { Table } from '../../../../components/Table/Table';
import ScreenTabsNavigation from '../../../../containers/ScreenTabsNavigation/ScreenTabsNavigation';
import CallCenterAgentSales from './containers/CallCenterAgentSales/CallCenterAgentSales';
import ItemSales from './containers/ItemSales/ItemSales';
import PaymentMethodSales from './containers/PaymentMethodSales/PaymentMethodSales';
import OrderingChannelSales from './containers/OrderingChannelSales/OrderingChannelSales';
import ComboSales from './containers/ComboSales/ComboSales';

const SalesDetails = () => {
  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <HeaderBack title="sales_details" path={SCREENS.REPORTS()} />
      </Headers>
      <div className="d-flex flex-column flex-grow-1 pt-6">
        <Table>
          <>
            <ScreenTabsNavigation
              options={[
                { path: SCREENS.CALL_CENTER_AGENT_SALES(), title: 'call_center_agent_sales' },
                { path: SCREENS.ITEM_SALES(), title: 'item_sales' },
                { path: SCREENS.PAYMENT_METHOD_SALES(), title: 'sales_per_payment_method' },
                { path: SCREENS.ORDERING_CHANNEL_SALES(), title: 'ordering_channel_sales' },
                { path: SCREENS.COMBO_SALES(), title: 'combo_sales_report_tab_name' },
              ]}
            />
            <Route path={SCREENS.CALL_CENTER_AGENT_SALES()} component={CallCenterAgentSales} />
            <Route path={SCREENS.ITEM_SALES()} component={ItemSales} />
            <Route path={SCREENS.PAYMENT_METHOD_SALES()} component={PaymentMethodSales} />
            <Route path={SCREENS.ORDERING_CHANNEL_SALES()} component={OrderingChannelSales} />
            <Route path={SCREENS.COMBO_SALES()} component={ComboSales} />
          </>
        </Table>
      </div>
    </div>
  );
};

export default SalesDetails;
